export const DEFAULT_MAX_UPLOAD_BYTES = 50 * 1024 * 1024;
export const DEFAULT_MAX_UPLOAD_FILE_COUNT = 1000;
export const DEFAULT_PROXY_UPLOAD_MAX_FILE_COUNT = 5;

export function resolveMaxUploadBytes(raw: string | undefined): number {
  const parsed = Number(raw);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : DEFAULT_MAX_UPLOAD_BYTES;
}

function resolvePositiveIntegerOrDefault(raw: string | undefined, fallback: number): number {
  const parsed = Number(raw);
  return Number.isInteger(parsed) && parsed > 0 ? parsed : fallback;
}

export function resolveMaxUploadFileCount(raw: string | undefined): number {
  return resolvePositiveIntegerOrDefault(raw, DEFAULT_MAX_UPLOAD_FILE_COUNT);
}

export function resolveProxyUploadMaxFileCount(raw: string | undefined): number {
  return resolvePositiveIntegerOrDefault(raw, DEFAULT_PROXY_UPLOAD_MAX_FILE_COUNT);
}
